import { ExternalLink } from "lucide-react";

import { summarizeLinks } from "./brandLinks";

function linkLabel(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}

export function LinkListCell({ links }: { links?: string[] | undefined }) {
  const { first, restCount, isEmpty } = summarizeLinks(links);

  if (isEmpty || !first) {
    return <span className="tw-text-muted-foreground">—</span>;
  }

  return (
    <div className="tw-flex tw-items-center tw-gap-1.5">
      <a
        href={first}
        target="_blank"
        rel="noopener noreferrer"
        title={first}
        className="tw-inline-flex tw-max-w-[160px] tw-items-center tw-gap-1 tw-text-sm tw-text-primary hover:tw-underline"
      >
        <ExternalLink className="tw-h-3 tw-w-3 tw-shrink-0" />
        <span className="tw-truncate">{linkLabel(first)}</span>
      </a>
      {restCount > 0 && (
        <span className="tw-rounded-full tw-border tw-border-border tw-bg-muted tw-px-1.5 tw-py-0.5 tw-text-[11px] tw-text-muted-foreground">
          +{restCount}
        </span>
      )}
    </div>
  );
}
